import React, { useEffect, useState } from "react";
import { Container, Grid, Button, AppBar, IconButton, Toolbar, Collapse, MenuList, Stack, List, ListItem, Card, Divider, Box, FormGroup, useScrollTrigger, OutlinedInput, FormLabel, TableContainer, TableRow, Table, TableCell, TableBody, Fade, ButtonGroup, ButtonBase } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import Logo from "../Shared/Logo";
import ConsentScripts from "../../utils/ConsentScripts";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDownAltIcon from "@mui/icons-material/South";
import PricingBoxes from "../Shared/PricingBoxes";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import Austria from 'images/austria.png';
import Europe from 'images/eu.png';
import DashboardImage from 'images/dashboard.jpg';
import KanbanImage from 'images/Kanban.jpg';
import ChatImage from 'images/chat.jpg';
import FeatureBg from 'images/feature-bg.jpg';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GppMaybeOutlinedIcon from '@mui/icons-material/GppMaybeOutlined';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import i18n from "i18next";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import InsightsIcon from '@mui/icons-material/Insights';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

const images = [
  ChatImage,
  DashboardImage,
];

const AUTO_SWITCH_MS = 4000;

const Landingpage = () => {
  const [menuShown, showMenu] = useState<boolean>(false);
  const [employees, setEmployees] = useState<number>(150);
  const [salesRate, setSalesRate] = useState<number>(75);
  const [savings, setSavings] = useState<number>(0);
  const [roi, setRoi] = useState<number>();

  useEffect(() => {
    const costs = employees * 1600 * salesRate * 0.025;
    const licenseCosts = employees * 10 * 12;
    const savingRate = costs * 0.25;
    setSavings(savingRate);

    const multiplier = Math.pow(10, 2);
    const roundedRoi = Math.round((licenseCosts/savingRate * 12) * multiplier) / multiplier;

    setRoi(roundedRoi);
  }, [employees, salesRate]);

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window,
  });

  const jumpToFeatures = () => {
    (window as any).lintrk('track', { conversion_id: 25691924 });
    const section = document.getElementById("how-it-works");
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const MenuItems = (props) => {
    return (
      <MenuList
        sx={{
          display: props.responsive ? { xs: "none", md: "flex" } : "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "center" },
          gap: { sx: 1, md: 2 },
          flexGrow: 1,
          [`a.MuiButton-root`]: { fontWeight: "400" }
        }}
      >
        {/* <Button fullWidth={!props.responsive}>
          Features
        </Button>
        <Button fullWidth={!props.responsive}>
          Use Cases
        </Button>
        <Button fullWidth={!props.responsive}>
          Pricing
        </Button>
        <Button fullWidth={!props.responsive}>
          FAQ
        </Button> */}

        <Stack
          direction="row"
          sx={{ marginLeft: "auto", display: { xs: "none", md: "flex" } }}
          spacing={1}
        >
          <Button
            variant="text"
            color="primary"
            size="small"
            component={NavLink}
            to="/login"
            sx={{['&:hover']: { backgroundColor: 'transparent !important' }}}
          >
            <span className="text-primary">Sign in</span>
          </Button>
          <Button
            component={NavLink}
            variant="text"
            color="secondary"
            size="small"
            to="/signup"
            sx={{['&:hover']: { backgroundColor: 'transparent !important' }}}
          >
            <span className="text-primary">Create workspace</span>
          </Button>
        </Stack>

        <Button
          component={NavLink}
          to="/login"
          sx={{ display: { md: "none" } }}
          fullWidth
        >
          Sign in
        </Button>

        <Button
          component={NavLink}
          to="/signup"
          sx={{ display: { md: "none" } }}
          fullWidth
        >
          Create workspace
        </Button>
      </MenuList>
    );
  };

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const nextProgress = Math.min(window.scrollY / 700, 1);
      const eased = 1 - Math.pow(1 - nextProgress, 3);
      setProgress(eased);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const rotateX = 30 - progress * 30;
  const marginTop = -12 - progress * -16;

  return <>
    <ConsentScripts />

    <AppBar component="nav" position="fixed" sx={{ background: trigger ? "var(--color-white) !important" : "transparent", boxShadow: trigger ? "var(--box-shadow-flat) !important" : "none" }}>
      <Toolbar sx={{ gap: "3rem" }}>
        <Logo color="primary" />
        <IconButton
          sx={{ marginLeft: "auto", display: { md: "none" } }}
          onClick={() => showMenu((shown) => !shown)}
          color="primary"
        >
          <MenuIcon />
        </IconButton>
        <MenuItems responsive />
      </Toolbar>
    </AppBar>

    <Collapse
      in={menuShown}
      className="bg-white"
      sx={{ position: "fixed", width: "100%", top: "56px", zIndex: 1, boxShadow: "var(--box-shadow-flat)", display: { md: "none" } }}
    >
      <MenuItems />
    </Collapse>

    <header className="bg-mesh bg-white" style={{ paddingTop: "8rem", paddingBottom: "7rem", overflow: "hidden" }}>
      <Container maxWidth="xl" className="text-center" sx={{position: "relative"}}>
        
        <Box className="animate__animated animate__fadeIn" sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
          <Box sx={{[`> h1`]: { fontSize: { md: "4rem", sm: "3rem", xs: "2rem" }, fontWeight: 600, letterSpacing: "-0.05rem" } }}><h1 className="text-special">Most <span className="text-info" style={{fontStyle: 'italic'}}>retrospectives are<br />forgotten</span> within 48 hours</h1></Box>
          <h3 className="text-light text-special" style={{opacity: 0.75, maxWidth: "75%"}}>
            Lessonice automatically captures decisions, action items and team learnings — so problems actually get resolved instead of repeated.
          </h3>
        </Box>

        <Stack direction="row" spacing={2} sx={{mt: 4, pb: 5, justifyContent: "center", zIndex: 1, position: "relative"}} className="animate__animated animate__fadeInUp">
          {/* <Button
            variant="outlined"
            color="secondary"
            size="large"
            component={Link}
            to="https://calendly.com/office-lessonice/demo"
            target="_blank"
            sx={{color: 'var(--color-white) !important', bgcolor: "transparent !important", borderColor: 'var(--color-white) !important' }}
          >
            Book a demo
          </Button> */}
          <Button
            variant="contained"
            color="info"
            size="large"
            endIcon={<ArrowDownAltIcon />}
            onClick={jumpToFeatures}
          >
            See how it works
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            size="large"
            component={NavLink}
            to="/signup"
            startIcon={<RocketLaunchIcon />}
          >
            Start for free
          </Button>
        </Stack>

        <Box sx= {{
          perspective: "900px",
        }}>
          <Box sx={{ 
            border: "1px solid var(--color-greyDark)",
            boxShadow: "var(--box-shadow)",
            borderRadius: "var(--border-radius)",
            zIndex: 0,
            mt: `${marginTop}vw`,
            transformOrigin: "center bottom",
            transformStyle: "preserve-3d",
            transform: `
              rotateX(${rotateX}deg)
              scale(0.9)
            `,
          }}>
            <FeatureSlideshow />
            {/* <img style={{
              width: "100%", 
              height: "100%", 
              borderRadius: 'var(--border-radius)', 
              display: 'block',
            }} src={AppImage} alt="Lessonice app" /> */}
          </Box>
        </Box>

      </Container>
    </header>

    <Divider />

    {/* <section className="bg-white" style={{ padding: "7rem 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid>
            <h3 className="text-info text-uppercase text-light">Projects end, people leave, insights vanish</h3>
            <h1 style={{margin: "1rem 0"}}>Is your lessons learned process leading nowhere?</h1>
            <List>
              <ListItem sx={{p: "0.5rem 0", gap: 1}} alignItems="flex-start">
                <GppMaybeOutlinedIcon color="secondary" sx={{mt: 0.9}} /> <h2 className="text-light text-secondary">You are not alone. Many companies conduct end-of-project retros that are barely sufficient.</h2>
              </ListItem>
              <ListItem sx={{p: "0.5rem 0", gap: 1}} alignItems="flex-start">
                <GppMaybeOutlinedIcon color="secondary" sx={{mt: 0.9}} /> <h2 className="text-light text-secondary">Ending in slides and spreadsheets nobody reads.</h2>
              </ListItem>
              <ListItem sx={{p: "0.5rem 0", gap: 1}} alignItems="flex-start">
                <GppMaybeOutlinedIcon color="secondary" sx={{mt: 0.9}} /> <h2 className="text-light text-secondary">Just to see the same mistakes coming back.</h2>
              </ListItem>
            </List>
          </Grid>
        </Grid>      
      </Container>
    </section> */}

    <section id="how-it-works" className="bg-secondary" style={{ padding: "7rem 0 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          
          <Grid size={{xs: 12, md: 6}}>
            <h3 className="text-info text-uppercase text-light" style={{marginTop: "3rem"}}>Capture Lessons Learned</h3>
            <h2 style={{margin: "1rem 0"}}>Enter your lesson in any language in our Lesson Capturer.</h2>
            <h3 className="text-light text-secondary" style={{margin: "1.5rem 0 2.5rem 0"}}>Catch them as you go in under 5 minutes. Anywhere. Anytime. Capture the issue in the moment it happens, not weeks after.</h3>
          </Grid>

          <Grid size={{xs: 12, md: 6}}>
            <Card className="text-center" sx={{p: "1rem !important"}}><img src={KanbanImage} alt="Capture Lessons Learned" style={{width: "100%"}} /></Card>
          </Grid>

        </Grid>      
      </Container>
    </section>

    <section className="bg-secondary" style={{ padding: "7rem 0 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={8}>

          <Grid size={{xs: 12, md: 6}}>
            <Card className="text-center" sx={{p: "1rem !important"}}><img src={FeatureBg} alt="" style={{width: "100%"}} /></Card>
          </Grid>
          
          <Grid size={{xs: 12, md: 6}}>
            <h3 className="text-info text-uppercase text-light" style={{marginTop: "3rem"}}>Root Cause Analysis</h3>
            <h2 style={{margin: "1rem 0"}}>Get through our AI guided 5-Why-analysis that helps you to get to the heart of the issue incl. assissted thinking.</h2>
            <h3 className="text-light text-secondary" style={{margin: "1.5rem 0 2.5rem 0"}}>No matter how you put your insides in Lessoncie. Everytime AI identifies your root-causes, creates a uniwue fishbone diagram and an execute summary to bring your 5-Why-Analysis to the spot and store it for you.</h3>
          </Grid>

        </Grid>      
      </Container>
    </section>

    <section className="bg-secondary" style={{ padding: "7rem 0 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          
          <Grid size={{xs: 12, md: 6}}>
            <h3 className="text-info text-uppercase text-light" style={{marginTop: "3rem"}}>Get Insights</h3>
            <h2 style={{margin: "1rem 0"}}>Get structured real-data for better insight and decision making, based on natrual language input.</h2>
            <h3 className="text-light text-secondary" style={{margin: "1.5rem 0 2.5rem 0"}}>All single lessons build-up your individual workspace dashboard to identify overall time losses, trends, root cause heatmap and our unique perception.</h3>
          </Grid>

          <Grid size={{xs: 12, md: 6}}>
            <Card className="text-center" sx={{p: "1rem !important"}}><img src={FeatureBg} alt="" style={{width: "100%"}} /></Card>
          </Grid>

        </Grid>      
      </Container>
    </section>

    <section className="bg-secondary" style={{ padding: "7rem 0 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={8}>

          <Grid size={{xs: 12, md: 6}}>
            <Card className="text-center" sx={{p: "1rem !important"}}><img src={FeatureBg} alt="" style={{width: "100%"}} /></Card>
          </Grid>
          
          <Grid size={{xs: 12, md: 6}}>
            <h3 className="text-info text-uppercase text-light" style={{marginTop: "3rem"}}>Drive Actions</h3>
            <h2 style={{margin: "1rem 0"}}>Assign SMART mitigation tasks and let Lessonice do the follow-up and follow-through.</h2>
            <h3 className="text-light text-secondary" style={{margin: "1.5rem 0 2.5rem 0"}}>Lessonice ensures mitigation tasks stay visible, accountable, and continuously moving forward.</h3>
          </Grid>

        </Grid>      
      </Container>
    </section>

    <section className="bg-secondary" style={{ padding: "7rem 0 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          
          <Grid size={{xs: 12, md: 6}}>
            <h3 className="text-info text-uppercase text-light" style={{marginTop: "3rem"}}>Close the Loop</h3>
            <h2 style={{margin: "1rem 0"}}>Next time you look up a lesson, the solution unfolds in front you. To prevent you from making them same mistake again.</h2>
            <h3 className="text-light text-secondary" style={{margin: "1.5rem 0 2.5rem 0"}}>Link any external ressources like work instructions, procedures, guidelines etc  safe and secure into Lessonice.</h3>
          </Grid>

          <Grid size={{xs: 12, md: 6}}>
            <Card className="text-center" sx={{p: "1rem !important"}}><img src={FeatureBg} alt="" style={{width: "100%"}} /></Card>
          </Grid>

        </Grid>      
      </Container>
    </section>

    <section style={{padding: "7rem 0"}} className="bg-secondary" data-nosnippet>
      <Container maxWidth="lg">
        <Card className="bg-mesh2 bg-dark text-center" sx={{padding: "5rem !important"}}>
          <FormGroup sx={{mb: 3}}>
            <h1 className="text-white text-special">This is real impact. This is Lessonice.</h1>
            <h2 className="text-white text-light text-special">Get your lessons learned to the next level</h2>
          </FormGroup>

          <Button
            variant="contained"
            color="primary"
            size="large"
            component={NavLink}
            to="/signup"
            startIcon={<RocketLaunchIcon />}
          >
            Start for free
          </Button>
        </Card>
      </Container>
    </section>

    <section className="bg-white" style={{ padding: "7rem 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          
          <Grid size={{xs: 12, md: 7}}>
            <h3 className="text-info text-uppercase text-light" style={{marginTop: "3rem"}}>Let's figure out how much your enterprise loses on avoidable mistakes</h3>
            <h1 style={{margin: "1rem 0"}}>Save <strong>{i18n.t('currency_label', { val: savings / 12, maximumFractionDigits: 0 })}</strong> monthly</h1>
            <h3 className="text-light text-secondary" style={{margin: "1.5rem 0 2.5rem 0"}}>Fill in your actual numbers in the ROI calculator to get an individual estimate. The result is based on the assumption that</h3>
            
            <Grid container spacing={3}>
              <Grid size={6}>
                <h2 className="text-lg" style={{marginBottom: 0}}>~1 hour</h2>
                <h3 className="text-secondary text-light"><span className="text-primary">per employee</span> / week is lost on average due to avoidable mistakes.</h3>
              </Grid>

              <Grid size={6}>
                <h2 className="text-lg" style={{marginBottom: 0}}>-25%</h2>
                <h3 className="text-secondary text-light"><span className="text-primary">mistake reduction</span> if Lessonice supports your decision making.</h3>
              </Grid>
            </Grid>
          </Grid>

          <Grid size={{xs: 12, md: 5}}>
            <Card className="text-center bg-dark">
              <FormGroup sx={{mb: 2}}><h2 className="text-white text-light">Return on Investment</h2></FormGroup>
              <FormGroup>
                <Grid container spacing={1}>
                  <Grid size={{xs: 12, md: 6}} textAlign="left" alignContent="center">
                    <FormLabel><span className="text-special text-white">Number of employees</span></FormLabel>
                  </Grid>
                  <Grid size={{xs: 12, md: 6}}><OutlinedInput
                                value={employees} 
                                onChange={e => setEmployees(Number(e.target.value))}
                                type="number" 
                                startAdornment={<Diversity3Icon color="secondary" />}
                                sx={{gap: 1}} /></Grid>
                </Grid>
              </FormGroup>
              <FormGroup>
                <Grid container spacing={1}>
                  <Grid size={{xs: 12, md: 6}} textAlign="left" alignContent="center">
                    <FormLabel><span className="text-special text-white">Average sales rate per employee</span></FormLabel>
                  </Grid>
                  <Grid size={{xs: 12, md: 6}}><OutlinedInput 
                                value={salesRate} 
                                onChange={e => setSalesRate(Number(e.target.value))}
                                type="number" 
                                startAdornment={<RequestQuoteIcon color="secondary" />}
                                /></Grid>
                </Grid>
              </FormGroup>

              <Divider sx={{mt: 2, mb: 3}} />

              <FormGroup>
                <h3 className="text-light text-white">Return on Investment</h3>
                <h2><strong className="text-white">after {roi ?? "-"} months</strong></h2>
              </FormGroup>

              <Divider sx={{mb: 2}} />

              <p className="text-secondary" style={{textAlign: "left", fontSize: "0.7rem"}}>*based on 1 lost hour per employee / week and a {i18n.t('currency_label', { val: 10, maximumFractionDigits: 0 })} per-seat license calculation.</p>
            </Card>
          </Grid>

        </Grid>      
      </Container>
    </section>

    {/* <section style={{padding: "7rem 0 0"}} className="bg-white" data-nosnippet>
      <Container maxWidth="lg">
        <FormGroup sx={{mb: 3}}>
          <h1 className="text-special text-center">Lessonice compared to other AI assistants</h1>
          <h3 className="text-light text-special text-secondary text-center">Here's how Lessonice compares to ChatGPT and Copilot.</h3>
        </FormGroup>

        <TableContainer sx={{mt: 5}}>
          <Table>
            <TableBody sx={{["td"]: { borderColor: "var(--color-purpleLight)"}}}>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="center" className="bg-info" sx={{pt: 3, borderTopLeftRadius: "var(--border-radius-button)", borderTopRightRadius: "var(--border-radius-button)"}}><h2>Lessonice</h2></TableCell>
                <TableCell align="center" sx={{pt: 3}}><h2 className="text-light">ChatGPT</h2></TableCell>
                <TableCell align="center" sx={{pt: 3}}><h2 className="text-light">Copilot</h2></TableCell>
              </TableRow>

              { featureTable.map((feature, index) => {

                const iconify = (value: string) => {
                  if (value === "Y") {
                    return <CheckIcon color="info" />;
                  }
                  if (value === "N") {
                    return <CloseIcon color="primary" />;
                  }
                  return <span className="text-primary">{value}</span>;
                }

                return <TableRow>
                  <TableCell><h3 className="text-light text-secondary">{feature.criteria}</h3></TableCell>
                  <TableCell align="center" className="bg-info"><FormLabel>{iconify(feature.lessonice)}</FormLabel></TableCell>
                  <TableCell align="center"><FormLabel>{iconify(feature.chatgpt)}</FormLabel></TableCell>
                  <TableCell align="center"><FormLabel>{iconify(feature.copilot)}</FormLabel></TableCell>
                </TableRow>
              })}
              <TableRow sx={{["td"]: { border: "none" }}}>
                <TableCell></TableCell>
                <TableCell align="center" className="bg-info"></TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </section> */}

    {/* <section style={{padding: "7rem 0"}} className="bg-secondary" data-nosnippet>
      <Container maxWidth="lg">
        <Card className="bg-mesh2 bg-dark text-center" sx={{padding: "5rem !important"}}>
          <FormGroup sx={{mb: 3}}>
            <h1 className="text-white text-special">Book your personal demo</h1>
            <h2 className="text-white text-light text-special">Get your lessons learned to the next level</h2>
          </FormGroup>

          <Button
            variant="contained"
            color="secondary"
            size="large"
            component={Link}
            to="https://calendly.com/office-lessonice/demo"
            target="_blank"
            startIcon={<EventAvailableIcon />}
          >
            Book a demo
          </Button>
        </Card>
      </Container>
    </section> */}

    {/* <section id="pricing" className="bg-secondary" style={{ padding: "7rem 0" }}>
      <Container maxWidth="lg">
        <FormGroup className="text-center" sx={{mb: 3}}>
          <h3 className="text-info text-uppercase text-light">Our prices scale with your business</h3>
          <h1 className="text-center text-primary">Flexible Pricing</h1>
        </FormGroup>
        <PricingBoxes />
      </Container>
    </section> */}

    <footer className="bg-black" style={{ padding: "3rem 0" }} data-nosnippet>
      <Container maxWidth="lg" sx={{ py: 5 }}>
        <p className="text-secondary text-uppercase text-light">Frequently asked questions</p>
        <h2 className="text-white text-lg text-special">Your concerns are important to us</h2>

        <Grid container spacing={5} sx={{mt: 5}}>
          <Grid size={{xs: 12, md: 6}}>
            <List>
              <FaqItem question="Will Lessonice use our data to train AI models?" answer="We won't use any of your data to train our AI models withouth your explicit consent. You can send us feedback anytime in order to optimize our algorithms. Any kind of info you voluntarily want to provide us together with your feedback is appreciated but not necessarily needed to be used to fine-tune our models." />
              <FaqItem question="Where is my company data hosted?" answer="Lessonice services are securely hosted on servers in the European Union that align with the highest safety and encryption standards." />
              <FaqItem question="What data does Lessonice access?" answer="We comply with the General Data Protection Regulation (GDPR) and the AI Act. Any kind of data in our system is consented and released by the users. In accordance with the GDPR, this data can be requested to be reviewed or removed at any time. This applies to all our services on offer." />
              <FaqItem question="How do you ensure that no company secrets are revealed?" answer="We give our best efforts to assure your data not being leaked or breached by any means. Nevertheless, any system can only be as conscientious and secure as its users. We endeavor to implement appropriate security precautions in line with the latest state of the art security measures to avoid any inconveniences." />
            </List>
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <List>
              <FaqItem question="What's the difference between Lessonice and ChatGPT?" answer="ChatGPT is an AI chatbot designed to engage in interactive conversations covering a wide range of different topics. However, ChatGPT does not have access to your company data. Lessonice in turn is a business software focused on sharing and discovering lessons learned, insights, and knowledge. It provides a structured way to document and retrieve company related data." />
              <FaqItem question="What's the difference between Lessonice and Microsoft Copilot?" answer="Microsoft Copilot is an AI assistant deeply integrated into the Microsoft ecosystem to enhance productivity. Lessonice as such enables enterprises to combine their knowledge in a more encapsulated way, so that not everything and every data is around that should not be there. As an enterprise-ready solution, Lessonice offers more opportunities to share knowledge on point." />
            </List>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg" sx={{ py: 5 }}>

        <Card className="bg-dark">
          <Grid container spacing={1}>
            <Grid size={{xs: 12, md: 8}}>
              <Logo color="white" />
              <List sx={{mt: 3}}>
                <ListItem sx={{px: 0, py: 1}}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <img src={Austria} width={42} height={42} alt="Made in Austria" />
                    <Box>
                      <p className="text-white">Made in Austria</p>
                      <p className="text-secondary">Proven by world leading industries</p>
                    </Box>
                  </Stack>
                </ListItem>
                <ListItem sx={{px: 0, py: 1}}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <img src={Europe} width={42} height={42} alt="GDPR & AI Act compliant" />
                    <Box>
                      <p className="text-white">GDPR &amp; AI Act compliant</p>
                      <p className="text-secondary">Securely hosted in the EU</p>
                    </Box>
                  </Stack>
                </ListItem>
              </List>
            </Grid>
            <Grid size={{xs: 12, md: 4}}>
              <p className="text-uppercase text-light text-secondary">Information</p>
              <List>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/terms" className="text-white">Terms of Service</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/privacy" className="text-white">Privacy Policy</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/beta" className="text-white">Beta Test Agreement</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/legal" className="text-white">Legal Notice</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/legal" className="text-white">Contact</NavLink></ListItem>
              </List>
            </Grid>
          </Grid>

          <Divider sx={{borderColor: 'var(--text-secondary) !important', my: 3, opacity: 0.5}} />

          <p className="text-secondary">
            &copy; Innomaze FlexCo
          </p>
        </Card>
      </Container>
    </footer>
  </>;
};

const featureTable = [
  {
    "criteria": "Lessons learned usability",
    "lessonice": "Specifically optimized for lessons learned",
    "chatgpt": "Very flexible, but lacks guidance",
    "copilot": "Good for standard Office tasks, not specialized for LL"
  },
  {
    "criteria": "Lessons learned capture",
    "lessonice": "Structured, workflow-based, throughout project lifecycle",
    "chatgpt": "spot-wise, no process guidance",
    "copilot": "Context-based, e.g., from Word/Teams/Planner data"
  },
  {
    "criteria": "Decision support",
    "lessonice": "Data-driven recommendations with impact evaluation",
    "chatgpt": "Hypothetical only via prompts",
    "copilot": "Not systematically available"
  },
  {
    "criteria": "Root cause anylasis",
    "lessonice": "Built-in, incl. visualization & categorization based on 5-Why, Fishbone",
    "chatgpt": "Ad-hoc, supported via manual dialog guidance",
    "copilot": "Only manual by user in tools like Excel/Word"
  },
  {
    "criteria": "Knowledge linking",
    "lessonice": "Automatic linking to project artifacts",
    "chatgpt": "Possible via manual prompting (e.g., 'refer to project X')",
    "copilot": "Manual linking or via SharePoint"
  },
  {
    "criteria": "Search & re-use ",
    "lessonice": "Semantic search, filtering, similarity analysis",
    "chatgpt": "Good in dialog ('Give me similar lessons from project Y')",
    "copilot": "Classic document search, no real re-use process"
  },
  {
    "criteria": "Integration into tools",
    "lessonice": "Seamless integration into common collaboration tools like MS Teams, Jira, Asana, etc.",
    "chatgpt": "Export/import possible, no native workflow",
    "copilot": "MS365 only"
  },
  {
    "criteria": "Analytics dashboard and data charts",
    "lessonice": "Y",
    "chatgpt": "N",
    "copilot": "N"
  },
  {
    "criteria": "Categorized root causes & clustering",
    "lessonice": "Y",
    "chatgpt": "~",
    "copilot": "N"
  },
  {
    "criteria": "Visual root cause mapping",
    "lessonice": "Y",
    "chatgpt": "~",
    "copilot": "N"
  },
  {
    "criteria": "Risk prediction",
    "lessonice": "Y",
    "chatgpt": "N",
    "copilot": "N"
  },
  {
    "criteria": "Trend analysis",
    "lessonice": "Y",
    "chatgpt": "N",
    "copilot": "N"
  },
  {
    "criteria": "Blind spot analysis",
    "lessonice": "Y",
    "chatgpt": "N",
    "copilot": "N"
  },
  {
    "criteria": "Use as project team",
    "lessonice": "Y",
    "chatgpt": "N",
    "copilot": "N"
  }
];

const FaqItem = (props: { question: string, answer: string }) => {

  const [isOpen, shouldOpen] = useState(false);

  return <ListItem disablePadding>
    <Box>
      <Stack sx={{cursor: "pointer"}} direction="row" onClick={() => shouldOpen(!isOpen)} alignItems="center" justifyContent="space-between">
        <h3 className="text-white text-light">{props.question}</h3>
        { isOpen ? <ExpandMoreIcon color="secondary" /> : <KeyboardArrowRightIcon color="secondary" /> }
      </Stack>
      <Collapse in={isOpen}>
        <p className="text-secondary">{props.answer}</p>
      </Collapse>
      <Divider sx={{borderColor: 'var(--text-secondary) !important', my: 2, opacity: 0.5}} />
    </Box>
  </ListItem>
}

function FeatureSlideshow() {
  const [activeIndex, setActiveIndex] = useState(0);

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % images.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, AUTO_SWITCH_MS);

    return () => clearInterval(interval);
  }, []);

  return <Box sx={{p: {xs: 1, lg: 2}, borderRadius: "var(--border-radius)",}}>

      {/* <ButtonGroup variant="contained" color="secondary" sx={{position: "absolute", zIndex: 1, top: "25px", p: 1, backgroundColor: "var(--background-dark)", borderRadius: "var(--border-radius)"}}>
        <Button startIcon={<AutoFixHighIcon />} sx={{color: activeIndex === 0 ? "var(--text-primary)" : "var(--text-white)", borderRadius: "var(--border-radius)"}}>From Retrospective</Button>
        <Button startIcon={<InsightsIcon />} sx={{color: activeIndex === 1 ? "var(--text-primary)" : "var(--text-white) !important", borderRadius: "var(--border-radius)"}}>To Dashboard</Button>
      </ButtonGroup> */}

      <Box
        sx={{
          overflow: "hidden",
          position: "relative",
          borderRadius: "var(--border-radius)",
          border: "1px solid var(--color-greyDark)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: `${images.length * 100}%`,
            transform: `translateX(-${activeIndex * (100 / images.length)}%)`,
            transition: "transform 0.6s ease-in-out",
            height: "100%",
          }}
        >
          {images.map((image, index) => (
            <Box
              key={index}
              component="img"
              src={image}
              alt={`slide-${index}`}
              sx={{
                width: `${100 / images.length}%`,
                objectFit: "cover",
                flexShrink: 0,
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>;
}

export default Landingpage;
